.header {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  .title {
    font-size: var(--font-size-h1-large);
    text-align: center;
    text-wrap: balance;

    @media (--md-down) {
      font-size: var(--font-size-h1-large-phone);
    }
  }

  .subtitle {
    font-size: var(--font-size-h2);
    font-weight: var(--font-weight-regular);
    text-align: center;
    text-wrap: balance;

    @media (--md-down) {
      font-size: var(--font-size-h2-phone);
    }
  }
}

.pagination {
  background-color: white;
}
